<template>
  <div>
    <el-dialog
      v-model="dialogFormVisible"
      :close-on-click-modal="false"
      :title="title"
      width="80%"
      @close="close"
    >
      <el-form ref="form" label-width="120px" :model="form" :rules="rules">
        <!-- 门店 -->
        <el-form-item label="门店" prop="branchId">
          <el-select
            v-model="form.branchId"
            placeholder="请选择门店"
            class="fix-width"
          >
            <el-option
              v-for="item in branchList"
              :key="item.branchId"
              :label="item.title"
              :value="item.branchId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="标题" prop="title">
          <el-input
            v-model.trim="form.title"
            class="fix-width"
            placeholder="请输入标题"
          />
        </el-form-item>
        <el-form-item label="设备编号" prop="key">
          <el-input
            v-model.trim="form.key"
            class="fix-width"
            placeholder="服务器地址"
          />
        </el-form-item>
        <el-form-item label="设备密钥" prop="secret">
          <el-input
            v-model.trim="form.secret"
            class="fix-width"
            placeholder="设备密钥"
            show-password
          />
        </el-form-item>
        <el-form-item label="备注" prop="text">
          <el-input
            v-model="form.text"
            type="textarea"
            class="fix-width"
            placeholder="请输入备注"
          />
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="form.order" placeholder="排序" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { createPrinter, updatePrinter } from '@/api/settings'
import { getAllBranchs } from '@/api/branch'
export default {
  name: 'PrinterEdit',
  emits: ['fetch-data'],
  data() {
    return {
      title: '',
      branchList: [],
      form: {
        printerId: '',
        title: '',
        branchId: '',
        key:'',
        secret:'',
        apiUrl: 'https://open-api.10ss.net/',
        user: '1055949972',
        usecret: 'e59337cfff9f7183ddc311da9374d557',
        ukey: 'd527915ca6e44ad1bf5e98a09eb00ed1',
        text: '',
        order: 1,
      },
      rules: {
        title: [{ required: true, trigger: 'blur', message: '请输入标题' }],
        branchId: [{ required: true, trigger: 'blur', message: '请选择门店' }],
        key: [
          { required: true, trigger: 'blur', message: '请输入设备编号' },
        ],
        secret: [{ required: true, trigger: 'blur', message: '请输入设备秘钥' }],
      },
      dialogFormVisible: false,
    }
  },
  methods: {
    //获取所有门店
    async getAllBranchs() {
      const res = await getAllBranchs({})
      if (!res) return
      this.branchList = res
    },
    async showEdit(row) {
      if (row) {
        this.title = '修改打印机'
        this.form = Object.assign(this.form, row.basic)
        this.form.printerId = row.printerId
        this.form.title = row.title
        this.form.branchId = row.extra.branchId
      } else {
        this.title = '新增打印机'
      }
      this.getAllBranchs()
      this.dialogFormVisible = true
    },
    close() {
      this.$refs['form'].resetFields()
      this.form = this.$options.data().form
      this.dialogFormVisible = false
    },
    save() {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          const printerId = this.form.printerId
          const data = Object.assign({}, this.form)
          this.$baseConfirm(
            `你确定要${printerId ? '修改' : '新增'}打印机吗`,
            null,
            async () => {
              printerId ? await updatePrinter(data) : await createPrinter(data)
              this.$baseMessage(
                `${printerId ? '修改' : '新增'}打印机成功`,
                'success',
                false,
                'vab-hey-message-success'
              )
              this.$emit('fetch-data')
              this.close()
            }
          )
        } else {
          return false
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@mixin size($scale: 1, $type: small) {
  @if $type == large {
    width: 343px * $scale;
  } @else {
    width: 167px * $scale;
  }
  height: 167px * $scale;
}
.avatar-uploader {
  .avatar {
    border-radius: 6px;
    transition: all 0.3s ease-in-out;
    @include size;

    &.large {
      @include size(1, large);
    }
  }
}
.icon_avatar {
  width: 50px;
  height: 50px;
}
.avatar-uploader-icon {
  border: 1px dashed #c0ccda;
  background-color: #fbfdff;
  border-radius: 6px;
  font-size: 28px;
  color: #8c939d;
  width: 148px;
  height: 148px;
  line-height: 148px;
  text-align: center;
}
.tags {
  margin-bottom: 5px;
}
.tags + .tags,
.tags + .button-new-tag {
  margin-left: 10px;
}
.button-new-tag {
  // margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
.disabled .el-upload--picture-card {
  display: none;
}
.fix-width {
  width: 500px;
}
.mb-10 {
  margin-bottom: 10px;
}
.tips {
  color: #aaaaaa;
  margin-left: 50px;
}
.el-icon-circle-plus-outline,
.el-icon-remove-outline {
  font-size: 32px;
  vertical-align: middle;
  cursor: pointer;
}

.el-icon-circle-plus-outline {
  color: #409eff;
}

.el-icon-remove-outline {
  color: #f56c6c;
  margin-left: 15px;
}
</style>
